import type HttpClient from "../../tastyworks/http"
import type { ItemsResponse } from "../../tastyworks/response"
import {
  SYMBOL_SEARCH_ITEM_DESER,
  SymbolSearchItem,
} from "../../tastyworks/symbol-search-item"

export default class SymbolSearchService {
  constructor(private readonly symbolsHttpClient: HttpClient) {}

  readonly search = async (
    path: string,
    query: string
  ): Promise<ItemsResponse<SymbolSearchItem>> =>
    this.symbolsHttpClient.indexSimple(
      SYMBOL_SEARCH_ITEM_DESER.toParser(SymbolSearchItem),
      `${path}/${encodeURIComponent(query)}`
    )

  readonly lookup = async (
    symbols: readonly string[]
  ): Promise<ItemsResponse<SymbolSearchItem>> =>
    this.symbolsHttpClient.indexSimple(
      SYMBOL_SEARCH_ITEM_DESER.toParser(SymbolSearchItem),
      // [MK]: creating the query string "manually" to avoid the comma separator
      // getting encoded. The API expects a unencoded-comma-separated list of symbols in the query string.
      `lookup?symbols=${symbols.map(encodeURIComponent).join(",")}`
    )
}
